import { ElementRef, Injectable } from '@angular/core';
import { APIService } from 'src/API.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoadingController, ToastController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Maps } from '../profile/profile.page';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class DriveCaroService {
  public logo = 'complete-name-logo';
  // days: '30',
  // price: '4400',
  course: any;
  studentDetails: any;
  offlineCar: any;
  offlineStudent = {
    phone: '',
    email: '',
    firstName: '',
    id: '',
    admissionId: '',
  };
  payment: any = {
    amountReceived: null,
    courseAmount: null,
    paymentDate: null,
    status: 'PENDING',
  }
  courseItem: any;
  courseDate: any;
  isCourseBooked: boolean = false;
  errorMessages: any = [];
  slotLength = 240;
  phone(phone: any, schoolId: string) {
    throw new Error('Method not implemented.');
  }
  public slotStatusMapper = {
    0: 'available',
    1: 'booked',
    2: 'bookedFemale',
    3: 'cancelled'
  }
  public scheduleStatusMapper = {
    1: 'PICKED',
    2: 'DRIVING',
    3: 'COMPLETED',
    4: 'DROPPED',
    0: 'PENDING'
  }
  loading: any;
  public appLoaded: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public webToken: string = '';
  public schoolId: string = '';
  public schools = [];
  public carList = [];
  // public pilotList = [];
  allSchToArchive = [];
  slotAvaiExt: any = [];
  config = {
    bufferDays: 0,
  }

  allScheduleList = [];
  filteredSchedulesDisplay = [];

  public courseStatusMapper = {
    1: 'Active',
    2: 'Active',
    3: 'Completed',
    4: 'Completed',
    0: 'Active'
  }


  schoolDetails: import("src/API.service").GetSchoolQuery;
  public searchElementRef: ElementRef;
  public readonly apiMap = this.load();
  hourlySlots = [];
  constructor(
    private api: APIService, private http: HttpClient,
    private loadingCtrl: LoadingController,
    private toastController: ToastController,
    private router: Router,
    private auth: AuthService,
  ) { }

  checkAppLoaded(): BehaviorSubject<number> {
    return this.appLoaded;
  }

  validateRoute() {
    return !this.schoolDetails.name || !this.schoolDetails.contactPerson
      || !this.schoolDetails.email || !this.schoolDetails.doorNumber
      || !this.schoolDetails.area || !this.schoolDetails.locality
      || !this.schoolDetails.pincode || !this.schoolDetails.landmark;
  }

  getCars() {
    // Query with filters, limits, and pagination
    const filter = {
      schoolCarListId: {
        eq: this.schoolId // filter priority = 1
      }
    };
    this.api.ListCars(filter).then((carList: any) => {
      console.log('carList list', carList);
      this.carList = carList.items.filter(x => !x._deleted);
      if (this.carList.length)
        this.carList[0].isSelected = true;
    })
      .catch((e) => {
        console.log('error getting cars...', e);
      });
  }

  createSchool(phone, userId) {
    const school = {
      id: userId,
      name: '',
      contactPerson: '',
      phone: phone,
      area: '',
      landmark: '',
      pincode: 0,
      staticMapAddress: ''
      // rating: '4',
      // distance: '4',
      // distanceFee: '4000',
      // kms: '5',
      // days: '30',
      // price: '4400',
    }
    this.api.CreateSchool(school).then(data => {
      this.schoolId = userId;
      this.schoolDetails = data;
      this.appLoaded.next(1);
      console.log('school created!', data);
    }).catch(e => {
      console.log('error', e);
    })
  }

  getRevGeo(body) {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${body.latitude},${body.longitude}&key=${environment.mapsKey}`
    return this.http.get(url);
  }

  createUserIfNotExists(user) {
    const userId = user.attributes.sub;
    const phone = user.attributes.phone_number;
    this.api.GetSchool(userId).then(data => {
      if (data === null) {
        this.createSchool(phone, userId)
      } else {
        console.log(data);
        this.schoolDetails = data;
        this.appLoaded.next(1);
      }
    }).catch(e => {
      console.log(e);
      // if (e.data === null) {
      //   this.createUser(phone, userId)
      // }
    })
  }
  // getPilots() {
  //   // Query with filters, limits, and pagination
  //   const filter = {
  //     schoolPilotId: {
  //       eq: this.studentId // filter priority = 1
  //     }
  //   };
  //   this.api.ListPilots(filter).then((pilotList: any) => {
  //     console.log('pilot list', pilotList);
  //     this.pilotList = pilotList.items.filter(x => !x._deleted);
  //   })
  //     .catch((e) => {
  //       console.log('error getting pilots...', e);
  //     });
  // }
  async showLoading(loadMsg = 'Fetching data..') {
    console.log('loader', loadMsg);
    this.loading = await this.loadingCtrl.create({
      message: loadMsg,
      duration: 1000,
      spinner: 'crescent',
    });

    this.loading.present();
  }
  async presentToast(message, color) {
    const toast = await this.toastController.create({
      message: message,
      duration: color === 'danger' ? 1500 : 1500,
      position: 'top',
      color: color
    });
    await toast.present();
  }

  private load(): Promise<Maps> {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    // tslint:disable-next-line:no-bitwise
    const callbackName = `GooglePlaces_cb_` + ((Math.random() * 1e9) >>> 0);
    script.src = this.getScriptSrc(callbackName);

    interface MyWindow { [name: string]: Function; };
    const myWindow: MyWindow = window as any;

    const promise = new Promise((resolve, reject) => {
      myWindow[callbackName] = resolve;
      script.onerror = reject;
    });
    document.body.appendChild(script);
    return promise.then(() => google.maps);
  }

  private getScriptSrc(callback: string): string {
    interface QueryParams { [key: string]: string; };
    const query: QueryParams = {
      v: '3',
      callback,
      key: 'AIzaSyAvHQwzrenXNxxyZJOv09e8qDhuQ4rGm6g',
      libraries: 'places',
      language: 'en',
      country: 'in'
    };
    const params = Object.keys(query).map(key => `${key}=${query[key]}`).join('&');
    return `https://maps.googleapis.com/maps/api/js?${params}`;
  }
  updateSchoolLocation(lat = 40.545870, long = -74.389985, rad = 40) {
    const url = `https://yna0hjo911.execute-api.ap-south-1.amazonaws.com/prod/addSchool-Prod`;
    const payload = {
      "id": this.schoolId,
      "position": {
        "lat": lat,
        "lon": long
      },
      "name": this.schoolDetails.name,
      "address": this.schoolDetails.staticMapAddress,
      "phone": this.schoolDetails.phone
    }
    return this.http.put(url, payload);
  }
  // validateRoute() {
  //   const data = this.schoolDetails;
  //   if (!data.name || !data.contactPerson) {
  //     this.presentToast('Please complete your profile', 'danger');
  //     return this.router.navigateByUrl('/profile');
  //   } else if (!data.carList.items.filter((x) => !x._deleted).length) {
  //     this.presentToast('Please add atleast one car', 'danger');
  //     return this.router.navigateByUrl(`/cars/true`);
  //   } else {
  //     this.appLoaded.next(1);
  //     return this.router.navigateByUrl('/dashboard');
  //   }
  // }
  createUser(mbl) {
    const payload = {
      id: `+91${mbl}`
    }
    const url = `https://l6ri0iayf0.execute-api.ap-south-1.amazonaws.com/prod/createStudent-Prod`;
    return this.http.post(url, payload);
  }

  sendSms(payload) {
    console.log('payload for sms', payload);
    const url = `https://qcj6yl222g.execute-api.ap-south-1.amazonaws.com/prod/sendsms`;
    return this.http.post(url, payload);
  }

  convertToDate(dateString) {
    //  Convert a "dd/MM/yyyy" string into a Date object
    let d = dateString.split("/");
    let dat = d[2] + '-' + (d[0].length > 1 ? d[0] : '0' + d[0]) + '-' + (d[1].length > 1 ? d[1] : '0' + d[1]);
    return dat;
  }

  removeWords(inputString) {
    // Create regular expressions to match the words "school" and "driving" case-sensitively
    const schoolRegex = /\bschool\b/i;
    const drivingRegex = /\bdriving\b/i;
    const motorRegex = /\bmotor\b/i;

    // Replace any occurrences of the words "school" and "driving" with an empty string
    let result = inputString.replace(schoolRegex, '').replace(drivingRegex, '').replace(motorRegex, '');
    result = this.removeSpaces(result);
    return result;
  }

  removeSpaces(input) {
    return input.replace(/\s/g, '');
  }
  removeSeconds(inputString) {
    // Split the input string by ':'
    var parts = inputString.split(':');

    // Remove the last element from the array
    parts.pop();

    // Join the remaining parts with ':'
    var result = parts.join(':');
    this.removeSpaces(result);
    return result;
  }

  getAllSlotsByCourseId(course, filterItem = null, nextToken = null) {
    console.log('suspendCourse 4', course);
    const courseFilter = filterItem || {
      courseCarScheduleId: {
        eq: course.id // filter priority = 1
      },
    };
    this.api.ListCarSchedules(courseFilter, 1000, nextToken).then(res => {
      if (res.nextToken) {
        console.log('next token available.. fetching results');
        this.allSchToArchive = [...this.allSchToArchive, ...res.items];
        this.getAllSlotsByCourseId(course, filterItem, res.nextToken);
        return;
      } else {
        this.allSchToArchive = [...this.allSchToArchive, ...res.items];
      }

      console.log('allSchToArchive', this.allSchToArchive);
      const totalSlots = this.allSchToArchive.length;
      this.allSchToArchive.forEach((item, index) => {
        console.log('suspendCourse 5', item);
        this.archiveSlots(item);
        if (index === totalSlots - 1) {
          this.loading.dismiss();
        }
      })
    })
  }

  markSuspend(course, isSuspend = true, courseToBook = null) {
    let courseToUpdate: any = {
      id: course.id,
      _version: course._version,
      courseSuspended: isSuspend,
    }

    if (!isSuspend) {
      courseToUpdate.courseEnd = courseToBook.courseEnd;
      courseToUpdate.courseStart = courseToBook.courseStart;
      courseToUpdate.timeSlot = courseToBook.timeSlot;
      courseToUpdate.courseName = courseToBook.courseName;
      courseToUpdate.completedClasses = courseToBook.completedClasses;
    }
    this.showLoading(`Marking course as Suspended...Please don't click exit the app or click back button...!`);
    this.api.UpdateCourse(courseToUpdate).then(res => {
      console.log(res);
      this.course = res;
      if (isSuspend) {
        this.slotAvaiExt = [];
        console.log('suspendCourse 1', res);
        this.updateSlotAvailable(res);
      }

      // this.getAllSlotsByCourseId(course);

    }).catch(e => {
      this.loading.dismiss();
      console.log('error', e);
    })
  }

  updateSlotAvailable(course, nextToken = null) {
    console.log('suspendCourse 2', course);
    const slotAvailFilter = {
      timeSlot: {
        eq: course.timeSlot
      },
      schoolSlotAvailabilityId: {
        eq: course.school.id
      },
      carSlotAvailabilityId: {
        eq: course.car.id
      }
    }
    this.api.ListSlotAvailabilities(slotAvailFilter, 1000, nextToken).then(res => {
      this.slotAvaiExt = [...this.slotAvaiExt, ...res.items];
      if (res.nextToken) {
        console.log('next token available.. fetching results');
        this.updateSlotAvailable(course, res.nextToken);
        return;
      } else {
        console.log('ListSlotAvailabilities', this.slotAvaiExt);
        const sltAval: any = this.slotAvaiExt[0];
        const updateSlotAvail = {
          id: sltAval.id,
          isBooked: false,
          _version: sltAval._version
        }
        this.api.UpdateSlotAvailability(updateSlotAvail).then(res => {
          console.log(res);
          // this.triggerArchive();
          console.log('suspendCourse 3', course);
          this.getAllSlotsByCourseId(course);
        }).catch(e => {
          this.presentToast(`Some error occured UpdateSlotAvailability! ${e.message}`, 'danger');
          this.loading.dismiss();
          console.log('error', e);
        })
      }
    }).catch(e => {
      console.log('error', e);
      this.presentToast(`Some error occured! ${e.message}`, 'danger');
      this.loading.dismiss();
    })
  }

  archiveSlots(selectedItem) {
    const archiveInput: any = {
      date: selectedItem.date,
      start: selectedItem.start,
      end: selectedItem.end,
      slotStatus: selectedItem.slotStatus,
      kmsDriven: selectedItem.kmsDriven,
      pickedTime: selectedItem.pickedTime,
      drivingStartedTime: selectedItem.drivingStartedTime,
      drivingCompletedTime: selectedItem.drivingCompletedTime,
      droppedTime: selectedItem.droppedTime,
      courseStatus: selectedItem.courseStatus,
      id: selectedItem.id,
      schoolScheduleArchiveId: selectedItem.schoolScheduleId,
      carScheduleArchiveId: selectedItem.carScheduleId,
      studentScheduleArchiveId: selectedItem.studentScheduleId,
      courseCarScheduleArchiveId: selectedItem.courseCarScheduleId,
    }
    if (selectedItem.addressCarScheduleId) {
      archiveInput.addressCarScheduleArchiveId = selectedItem.addressCarScheduleId
    }
    this.api.CreateCarScheduleArchive(archiveInput).then(res => {
      console.log(res);
      this.deleteSchedule(selectedItem);
    }).catch(e => {
      this.presentToast(`Some error occured! ${e.message}`, 'danger');
      console.log('error', e);
      this.loading.dismiss();
    })
  }

  deleteSchedule(selectedItem) {
    const deleteItem = {
      id: selectedItem.id,
      _version: selectedItem._version
    }
    this.api.DeleteCarSchedule(deleteItem).then(res => {
      console.log(res);
    }).catch(e => {
      this.loading.dismiss();
      this.presentToast(`Some error occured! ${e.message}`, 'danger');
      console.log('error', e);
    })
  }

  getSlotStatus(filterItem = null, nextToken = null) {
    const filter = filterItem || {
      carScheduleId: {
        eq: this.course.car.id // filter priority = 1
      },
      schoolScheduleId: {
        eq: this.course.school.id
      },
      courseCarScheduleId: {
        eq: this.course.id
      },
    }
    this.api.ListCarSchedules(filter, 1000, nextToken).then(res => {
      if (res.nextToken) {
        console.log('next token available.. fetching results');
        this.allScheduleList = [...this.allScheduleList, ...res.items];
        this.getSlotStatus(filter, res.nextToken);
        return;
      } else {
        this.allScheduleList = [...this.allScheduleList, ...res.items];
      }

      // this.allScheduleList = this.allScheduleList.sort((a, b) => a.date - b.date);
      // this.allScheduleList = this.allScheduleList.sort((a, b) => new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime());
      this.allScheduleList = this.allScheduleList.sort((a, b) => {
        if (a.date < b.date) {
          return -1;
        }
        if (a.date > b.date) {
          return 1;
        }
        // if firstKey is the same, compare by secondKey
        if (a.updatedAt < b.updatedAt) {
          return -1;
        }
        if (a.updatedAt > b.updatedAt) {
          return 1;
        }
        return 0;
      });
      console.log('allScheduleList', this.allScheduleList);
      // if (this.allScheduleList.length) {
      //   const todayDate = new Date(today.toLocaleDateString('en-US')).getTime();
      //   const tomDate = new Date(new Date(tom).toLocaleDateString('en-US')).getTime();
      //   const dayAferDate = new Date(new Date(dayAfer).toLocaleDateString('en-US')).getTime();
      //   if (this.activeStatus.showToday) {
      //     this.courseSlotItem['showToday'] = this.allScheduleList.find(slot => +slot.date === todayDate);
      //     this.slotRating = this.courseSlotItem['showToday'].rating;
      //     this.courseSlotStatus['showToday'] = this.courseSlotItem['showToday'].slotStatus;
      //     // this.activeStatus.showToday = this.activeStatus.showToday && this.courseSlotItem['showToday'].courseStatus === 0;
      //   }
      //   if (this.activeStatus.showTom) {
      //     this.courseSlotItem['showTom'] = this.allScheduleList.find(slot => +slot.date === tomDate);
      //     this.courseSlotStatus['showTom'] = this.courseSlotItem['showTom'].slotStatus;
      //     this.activeStatus.showTom = this.activeStatus.showTom && this.courseSlotItem['showTom'].courseStatus === 0;
      //   }
      //   if (this.activeStatus.showDayAfter) {
      //     this.courseSlotItem['showDayAfter'] = this.allScheduleList.find(slot => +slot.date === dayAferDate);
      //     this.courseSlotStatus['showDayAfter'] = this.courseSlotItem['showDayAfter'].slotStatus;
      //     this.activeStatus.showDayAfter = this.activeStatus.showDayAfter && this.courseSlotItem['showDayAfter'].courseStatus === 0;
      //   }
      //   console.log(this.courseSlotItem);
      // }
      // const allSch = this.allScheduleList;
      // this.notStarted = allSch.filter(x => !x.courseStatus);
      // const compIndex = allSch.findIndex(x => new Date(x.drivingStartedTime).toLocaleDateString() === new Date().toLocaleDateString());
      // if (compIndex !== -1) {
      //   this.notStarted = allSch.slice(compIndex)
      // }
      // console.log('notstarted', this.notStarted, allSch);
      // this.courseSlotItem['showToday'] = this.notStarted[0];
      // this.courseSlotItem['showTom'] = this.notStarted[1];
      // this.courseSlotItem['showDayAfter'] = this.notStarted[2];
      // this.classNumber.showToday = this.courseSlotItem['showToday'].slotStatus === 3 ? 'NA' : this.course.completedClasses + 1;
      // this.classNumber.showTom = this.courseSlotItem['showTom'].slotStatus === 3 ? 'NA' : (this.courseSlotItem['showToday'].slotStatus === 3 ? this.course.completedClasses + 1 : this.course.completedClasses + 2);

      // this.classNumber.showDayAfter = this.course.completedClasses + classToAdd;
      // let classToAddToday: any = this.allScheduleList.length - this.notStarted.length + 1;
      // if (this.courseSlotItem['showToday'].slotStatus === 3) {
      //   classToAddToday = 'NA';
      // }
      // this.classNumber.showToday = classToAddToday;

      // let classToAddTom: any = this.allScheduleList.length - this.notStarted.length + 2;
      // if (this.courseSlotItem['showToday'].slotStatus === 3) {
      //   classToAddTom = classToAddTom - 1;
      // }
      // if (this.courseSlotItem['showTom'].slotStatus === 3) {
      //   classToAddTom = 'NA';
      // }
      // this.classNumber.showTom = classToAddTom;
      // let classToAdd: any = this.allScheduleList.length - this.notStarted.length + 3;;
      // if (this.courseSlotItem['showToday'].slotStatus === 3) {
      //   classToAdd = classToAdd - 1;
      // }
      // if (this.courseSlotItem['showTom'].slotStatus === 3) {
      //   classToAdd = classToAdd - 1;
      // }
      // if (this.courseSlotItem['showDayAfter'].slotStatus === 3) {
      //   classToAdd = 'NA';
      // }
      // this.classNumber.showDayAfter = classToAdd;
      let todayDate = new Date(new Date().toLocaleDateString('en-US'));
      const dayAfterDate = todayDate.setDate(new Date().getDate() + 2);
      let clsCounter = 1;
      this.allScheduleList.forEach((x) => {
        //  && new Date(+x.date).getTime() >= todayDate.getTime()
        // console.log(new Date(+x.date), todayDate, new Date(+x.date).getTime() >= todayDate.getTime());
        // && new Date(+x.date).getTime() >= new Date(new Date().toLocaleDateString('en-US')).getTime() --- condition to restrict yesteday's missed classes.
        if (new Date(+x.date).getTime() <= dayAfterDate) {
          x.showCancel = true;
        }
        if (x.slotStatus === 3) {
          x.classNumber = 'NA';
        } else {
          if (!x.classNumber) {
            x.classNumber = x.course.completedClasses + clsCounter;
            clsCounter++;
          }
        }
        if (x.drivingCompletedTime && x.drivingStartedTime)
          x.classDuration = (new Date(x.drivingCompletedTime).getTime() - new Date(x.drivingStartedTime).getTime()) / (1000 * 60)
      })
      // let lastIndex = -1;
      // for (let i = 0; i < this.allScheduleList.length; i++) {
      //   if (this.allScheduleList[i].showCancel) {
      //     lastIndex = i;
      //   }
      // }
      // lastIndex = this.allScheduleList.findIndex(x => dayAfterDate === +x.date);
      // this.allScheduleList = lastIndex !== -1 ? this.allScheduleList.slice(0, lastIndex + 1) : [];
      this.filteredSchedulesDisplay = [];
      this.filteredSchedulesDisplay = [...this.allScheduleList].filter(x => +x.date <= dayAfterDate);
      console.log('filtered', this.filteredSchedulesDisplay);

    }).catch(e => {
      console.log('error', e);
    })
  }

  getSubdomain = () => {
    const host = window.location.hostname; // e.g., "sub.example.com"
    const parts = host.split('.');
    if (parts.length > 2) {
      return parts.slice(0, parts.length - 2).join('.'); // Handles multi-level subdomains
    }
    return null; // No subdomain
  };


  getDomainData(subdomain) {
    const filter = {
      subdomain: {
        eq: subdomain // filter priority = 1
      }
    };
    this.api.ListDomainMappers(filter).then((res) => {
      console.log('getDomaindata', res);
      if (res.items.length && res.items[0].themeColor)
        this.updateColor(res.items[0].themeColor);
    }).catch(e => {
      console.log('error', e);
    })
  }


  updateColor(selectedColor) {
    document.documentElement.style.setProperty('--mountain-meadow', selectedColor);
    console.log(selectedColor);
    document.documentElement.style.setProperty('--aqua-squeeze', `${selectedColor}0a`);
  }

  logout() {
    this.auth.signOut();
    this.webToken = '';
    this.router.navigateByUrl('/login');
    this.carList = [];
    // this.pilotList = [];
    this.schoolId = '';
    this.schools = [];
    // window.location.reload();
  }

  getEffectiveDuration(car) {
    const effDur = car.slotDuration / car.seatsOffered;
    console.log('getEffectiveDuration', effDur)
    return effDur;
  }

  generateHourlySlots(car, date) {
    this.hourlySlots = [];
    let startTime = new Date(car.dayStart.replace(car.dayStart.substring(0, 10), this.convertToDate(new Date(date.date).toLocaleDateString('en-US'))));
    let carDayEndTime = new Date(car.dayEnd.replace(car.dayEnd.substring(0, 10), this.convertToDate(new Date(date.date).toLocaleDateString('en-US'))));
    let endTime = new Date(startTime);
    endTime.setMinutes(endTime.getMinutes() + car.slotDuration);
    for (let i = 0; i < this.slotLength; i++) {
      if (new Date(endTime).getTime() > new Date(carDayEndTime).getTime()) {
        break;
      }
      const start = new Date(startTime).toISOString();
      const dateToAdd = new Date(date.date).toLocaleDateString('en-US');
      // const availIdx = this.availableSlots.findIndex(x => (x.timeSlot.split('Z-')[0] + 'Z').substring(11, 19) === start.substring(11, 19));
      // if (availIdx === -1) {
      const slot: any = {
        // date: new Date(dateToFill).getTime(),
        start: new Date(startTime).toISOString(),
        end: new Date(endTime).toISOString(),
        // slotStatus: 0,
        // courseStatus: 0,
        // schoolScheduleId: this.schoolId,
        // carScheduleId: car.id,
      };
      // if (new Date().getTime() > new Date(slot.start).getTime()) {
      //   slot.isDisabled = true;
      // }
      this.hourlySlots.push(slot);
      startTime = new Date(endTime);
      endTime.setMinutes(endTime.getMinutes() + car.slotDuration || 30);
    }
    console.log('generateHourlySlots', this.hourlySlots);
  }
}
